module.exports = __webpack_public_path__ + "img/00025.142326a2.webp";